import React from "react";
import "./chatuser.css";

function chatuser(props) {
return (
  <div className="krunk-chat1" style={{ marginTop: '8px', paddingTop: '0', paddingBottom: '0' }}>
    <div  
     className="krunk-bg-headercolor krunk-text-bubbletext"
      // className="krunk-bg-bubblecolor krunk-text-textcolor"
      style={{
        maxWidth: '250px',
        padding: '0 7px',
        borderRadius: '8px 0 8px 8px',
        border: '1px solid #fff',
      }}>
      <p style={{ paddingTop: '0', paddingBottom: '0', margin: '10px 0' }}>{props.message.text}</p>
    </div>
  </div>
);
}

export default chatuser;
